"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TextInput = function TextInput(_ref) {
  var className = _ref.className,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      hasErrorIcon = _ref.hasErrorIcon,
      infoMessage = _ref.infoMessage,
      disabled = _ref.disabled,
      disableTyping = _ref.disableTyping,
      multiline = _ref.multiline,
      props = _objectWithoutProperties(_ref, ["className", "error", "errorMessage", "hasErrorIcon", "infoMessage", "disabled", "disableTyping", "multiline"]);

  var classNames = (0, _classnames.default)(className, 'text-input', {
    'is-error': error,
    'is-disabled': disabled
  });
  var tagName = multiline ? 'textarea' : 'input';
  var isDisabled = disabled || disableTyping;

  var InputComponent = _react.default.createElement(tagName, _objectSpread({
    'data-text-input': true,
    className: classNames,
    disabled: isDisabled
  }, props));

  return _react.default.createElement("div", {
    className: "text-input__wrapper"
  }, InputComponent, error && errorMessage ? _react.default.createElement("p", {
    "data-error-message": true,
    className: "error-text u-display-flex u-justifyContent-spaceBetween",
    style: {
      alignItems: 'flex-start'
    }
  }, _react.default.createElement("span", {
    className: "u-flex-grow-1"
  }, errorMessage), hasErrorIcon && _react.default.createElement("span", {
    className: "u-flex-grow-0 u-fontSize-xxl u-paddingLeft-xs u-display-flex"
  }, _react.default.createElement(_Icons.IconUiWarningCircle, null))) : null, !errorMessage && infoMessage ? _react.default.createElement("p", {
    "data-info-message": true,
    className: "u-display-flex u-justifyContent-spaceBetween u-marginTop-xxxs",
    style: {
      alignItems: 'flex-start'
    }
  }, _react.default.createElement("span", {
    className: "u-flex-grow-1"
  }, infoMessage)) : null);
};

TextInput.displayName = 'TextInput';
TextInput.propTypes = {
  /** Any classnames that you want to apply to the component */
  className: _propTypes.default.string,

  /** Apply error styling to the input */
  error: _propTypes.default.bool,

  /** Error message to display underneath the input */
  errorMessage: _propTypes.default.string,

  /** Enable the showing of the error icon after the error message */
  hasErrorIcon: _propTypes.default.bool,

  /** Info message to display underneath the input */
  infoMessage: _propTypes.default.string,

  /** Disable the input */
  disabled: _propTypes.default.bool,

  /** Disable typing but do not apply disabled styled */
  disableTyping: _propTypes.default.bool,

  /** Enable multiline text by using a textarea */
  multiline: _propTypes.default.bool
};
TextInput.defaultProps = {
  hasErrorIcon: true
};

var TextInputWithCounter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextInputWithCounter, _React$Component);

  function TextInputWithCounter(props) {
    var _this;

    _classCallCheck(this, TextInputWithCounter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextInputWithCounter).call(this));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMessageProps", function () {
      var characterCount = _this.state.characterCount;
      var _this$props = _this.props,
          counterTextLimitMessage = _this$props.counterTextLimitMessage,
          counterTextLimitExceededMessage = _this$props.counterTextLimitExceededMessage;
      var isOverCount = characterCount < 0;

      if (isOverCount) {
        var overCount = characterCount * -1;
        return {
          error: characterCount < 0,
          hasErrorIcon: false,
          errorMessage: counterTextLimitExceededMessage(overCount)
        };
      }

      return {
        infoMessage: counterTextLimitMessage(characterCount)
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (e) {
      var eventValue = e.target.value;
      var _this$props2 = _this.props,
          value = _this$props2.value,
          characterLimit = _this$props2.characterLimit,
          onChange = _this$props2.onChange;
      var textValue = value || eventValue;
      var characterCount = characterLimit - textValue.length;

      _this.setState({
        value: textValue,
        characterCount: characterCount
      });

      if (onChange) {
        onChange(characterCount < 0, e);
      }
    });

    _this.state = {
      value: props.value,
      characterCount: props.characterLimit
    };
    return _this;
  }

  _createClass(TextInputWithCounter, [{
    key: "render",
    value: function render() {
      // Extract from props so they are not passed to TextInput
      var _this$props3 = this.props,
          characterLimit = _this$props3.characterLimit,
          counterTextLimitMessage = _this$props3.counterTextLimitMessage,
          counterTextLimitExceededMessage = _this$props3.counterTextLimitExceededMessage,
          props = _objectWithoutProperties(_this$props3, ["characterLimit", "counterTextLimitMessage", "counterTextLimitExceededMessage"]);

      return _react.default.createElement(TextInput, _extends({}, props, {
        onChange: this.handleChange,
        value: this.state.value
      }, this.getMessageProps()));
    }
  }]);

  return TextInputWithCounter;
}(_react.default.Component);

TextInputWithCounter.displayName = 'TextInputWithCounter';
TextInputWithCounter.propTypes = {
  /** The value of the TextInput */
  value: _propTypes.default.string,

  /** Function that is called on change which passes the isOverLimit flag and event */
  onChange: _propTypes.default.func,

  /** The value of the TextInput */
  characterLimit: _propTypes.default.number.isRequired,

  /** Function that will return a string message to display when
   * the limit has not yet been reached */
  counterTextLimitMessage: _propTypes.default.func.isRequired,

  /** Function that will return a string message to display when
   *  the limit has been reached or is over */
  counterTextLimitExceededMessage: _propTypes.default.func.isRequired
};
TextInput.WithCounter = TextInputWithCounter;
var _default = TextInput;
exports.default = _default;